import { GoogleAd } from '~/models/ads'

export const plotViewMobileTopGoogleAd: GoogleAd = {
  path: '/297119706/plot_cls_mb_top1',
  id: 'div-gpt-ad-1629970982899-0',
  sizes: [320, 100]
}

export const plotViewMobileBottomGoogleAd: GoogleAd = {
  path: '/297119706/plot_cls_mb_top',
  id: 'div-gpt-ad-1629969729092-0',
  sizes: [
    [336, 280],
    [360, 300],
    [300, 250]
  ],
  sizesMappings: [
    [[360, 300], [[360, 300]]],
    [[336, 280], [[336, 280]]],
    [[300, 250], [[300, 250]]],
    [[0, 0], []]
  ]
}

export const plotViewDesktopTopGoogleAd: GoogleAd = {
  path: '/297119706/plot_cls_dt_top',
  id: 'div-gpt-ad-1632306660078-0',
  sizes: [300, 250]
}
